function MenuTypeSwitch({ value, onChange, label, foodsLabel, drinksLabel }) {
  return (
    <div className="menu-type-switch" role="group" aria-label={label}>
      <button
        type="button"
        className={
          value === "food" ? "menu-type-btn is-active" : "menu-type-btn"
        }
        aria-pressed={value === "food"}
        onClick={() => onChange("food")}
      >
        {foodsLabel}
      </button>
      <button
        type="button"
        className={
          value === "drink" ? "menu-type-btn is-active" : "menu-type-btn"
        }
        aria-pressed={value === "drink"}
        onClick={() => onChange("drink")}
      >
        {drinksLabel}
      </button>
    </div>
  );
}

export default MenuTypeSwitch;
